namespace Matrix {

	@Serenity.Decorators.registerFormatter()
	export class PercentFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (ctx.value == null)
                return "";

            var format = "#0";
            if (this.decimalPlaces) {
                format += ".";
                for (var i = 0; i < this.decimalPlaces; i++)
                    format += "0";
            }

            return Q.formatNumber(ctx.value * 100, format) + '%';
		}

	    @Serenity.Decorators.option()
	    decimalPlaces: number;

	}
}